import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import Draggable from 'react-draggable'
import { VideoPlayer } from '../../../../legacy'
import mobileDetect from 'aria-viewer/utils/mobileDetect'

const isMobile = mobileDetect.mobile()

const S = {
    currentTime: {
        display: 'inline-block',
        float: 'left',
    },
    totalTime: {
        display: 'inline-block',
        float: 'right',
    },
}

class VideoScrubBar extends Component {
    static propTypes = {
        player: PropTypes.object.isRequired,
    }

    static contextTypes = {
        width: PropTypes.number,
        height: PropTypes.number,
    }

    static defaultProps = {
        height: 4,
        markerWidth: 24,
        markerHeight: 24,
    }

    constructor(props) {
        super(props)

        this.state = props.player
            ? props.player.getProgressInfo()
            : {
                  seconds: 0,
                  duration: 0,
                  percent: 0,
                  buffered: 0,
              }

        this.dragging = false
    }

    init = (props, nextProps) => {
        if (props !== nextProps || props.player !== nextProps.player) {
            nextProps.player.onProgress(this.handleOnProgress)
            nextProps.player.onBuffer(this.handleOnBuffer)
        }
        this.updateWidth()
    }

    componentWillMount() {
        this.init(null, this.props)
    }

    componentWillReceiveProps(nextProps) {
        this.init(this.props, nextProps)
    }

    componentWillUnmount() {
        const { player } = this.props
        const { LOAD_PROGRESS, PLAY_PROGRESS } = VideoPlayer.events

        player.off(LOAD_PROGRESS)
        player.off(PLAY_PROGRESS)
    }

    updateWidth = () => {
        const { style = { width: '401px' } } = this.props

        this.width = style.width.endsWith('%') ? this.context.width * (Number.parseInt(style.width) / 100) : style.width
    }

    handleDrag = (e, ui) => {
        const { player, onChange } = this.props

        onChange && onChange(e)

        this.dragging = true
        // Sets percent state
        this.updateProgress(ui.x)

        const { percent, duration } = this.state
        const seconds = (percent / 100) * duration

        this.setState({ seconds })

        player.trigger(VideoPlayer.events.PLAY_PROGRESS, { seconds, duration })
    }

    handleDrop = (e, ui) => {
        const { player } = this.props
        const { percent, duration } = this.state
        const seconds = (percent / 100) * duration

        this.dragging = false

        player.seek(seconds || 0)
        player.play()
    }

    handleOnProgressClick = e => {
        this.props.onChange && this.props.onChange(e)
        this.progressClicked = true

        const mouse = e.pageX || e.touches[0].pageX

        const x = (this.refs.slider.getBoundingClientRect().left - mouse + this.props.markerWidth / 2) * -1

        const { player } = this.props

        player.pause()

        this.refs.marker.setState({ x })
        this.updateProgress(x)
    }

    handleOnMouseUp = e => {
        const { player } = this.props
        const { percent, duration } = this.state
        const seconds = (percent / 100) * duration

        this.progressClicked = false
        player.seek(seconds || 0)
        player.play()
    }

    handleOnProgress = ({ seconds, duration, percent }) => {
        if (!this.dragging && !this.progressClicked && this.refs.marker) {
            this.setState({
                seconds,
                duration,
                percent: percent * 100,
            })

            this.refs.marker.setState({ x: percent * Number.parseInt(this.width) })
        }
    }

    handleOnBuffer = ({ buffered }) => {
        this.setState({ buffered: buffered * 100 })
    }

    updateProgress = x => {
        const percent = Math.round((x / (Number.parseInt(this.width) - this.props.markerWidth)) * 100.0)

        if (percent < 0) {
            this.setState({ percent: 0 })
        } else {
            this.setState({ percent })
        }
    }

    render() {
        // TODO: REFACTOR THIS COMPONENT

        const { seconds, duration, percent, buffered } = this.state
        const markerX = Math.round((percent * Number.parseInt(this.width)) / 100.0)
        const { style, height, markerWidth, markerHeight, markerTop } = this.props

        const top = markerTop ? markerTop : -markerHeight / 2

        // only add mouseup event on desktop because the draggable
        // will be fighting with it
        const mouseTouchEvents = !isMobile
            ? {
                  onMouseUp: this.handleOnMouseUp,
              }
            : {}

        return (
            /* Scrub Bar Container */
            <div
                className={'video-ui-scrubbar'}
                style={Object.assign(
                    {},
                    { ...style, videoDuration: undefined },
                    {
                        width: this.width,
                        pointerEvents: 'all',
                    }
                )}
            >
                {/* Video Progress */}
                <div
                    className={'video-ui-progress'}
                    ref="slider"
                    onTouchStart={this.handleOnProgressClick}
                    onMouseDown={this.handleOnProgressClick}
                    {...mouseTouchEvents}
                    style={{
                        height,
                        position: 'relative',
                        cursor: 'pointer',
                        background: 'rgba(255,255,255,0.5)',
                        pointerEvents: 'all',
                    }}
                >
                    {/* Buffer Bar */}
                    <div
                        style={{
                            position: 'absolute',
                            height,
                            width: `${buffered}%`,
                            bottom: 0,
                            background: 'rgba(255,255,255,0.8)',
                        }}
                    />
                    {/* Bar */}
                    <div
                        style={{
                            position: 'absolute',
                            height,
                            width: `${percent}%`,
                            bottom: 0,
                            background: styleguide.colors['teal'],
                        }}
                    />
                    {/* Marker */}
                    <Draggable
                        ref="marker"
                        axis="x"
                        handle=".marker"
                        defaultPosition={{ x: markerX, y: 0 }}
                        onDrag={this.handleDrag}
                        onStop={this.handleDrop}
                        bounds={{ left: 0, top: 0, right: Number.parseInt(this.width) - markerWidth, bottom: 0 }}
                    >
                        <div
                            className="marker"
                            style={{
                                position: 'absolute',
                                top,
                                width: `${markerWidth}px`,
                                height: `${markerHeight}px`,
                                left: 0,
                                background: styleguide.colors['white'],
                                ...styleguide.rounded,
                            }}
                        />
                    </Draggable>
                </div>

                {/* Video Duration Container */}
                <div
                    style={{
                        color: styleguide.colors['white'],
                        marginTop: 1,
                        fontSize: 16,
                        ...style.videoDuration,
                        padding: '10px 0',
                    }}
                >
                    {/*Current Time*/}
                    <div style={S.currentTime}>{VideoPlayer.toTime(seconds)}</div>

                    {/*Total Time*/}
                    <div style={S.totalTime}>{VideoPlayer.toTime(duration)}</div>
                </div>
            </div>
        )
    }
}
export default VideoScrubBar
